import { Option } from "@/components/select/AsyncAutocompleteSelect";
import { GetECheqRequestsProps } from "@/services/echeq-requests.service";
import dayjs, { Dayjs } from "dayjs";
import { formatCurrencyInputToNumber } from "@/utils/query-string";

export interface ECheqFilterProps {
  fecha_desde?: Dayjs;
  fecha_hasta?: Dayjs;
  sucursal?: string[];
  request_amount?: string;
  requester?: string;
  account_number?: Option;
  estados?: number[];
}

export const getECheqRequestFilter = (
  event: ECheqFilterProps,
): Partial<GetECheqRequestsProps> => {
  let amount: string | undefined;

  const estados = Array.isArray(event?.estados)
    ? (event.estados as unknown[]).reduce<number[]>((acc, item) => {
        if (Array.isArray(item)) {
          return acc.concat(item as number[]);
        }
        if (typeof item === "string") {
          const parsed = item
            .split("|")
            .map(Number)
            .filter((n) => Number.isFinite(n));
          return acc.concat(parsed);
        }
        if (typeof item === "number") {
          acc.push(item);
        }
        return acc;
      }, [])
    : [];

  if (event?.request_amount) {
    const num = formatCurrencyInputToNumber(event.request_amount);

    if (!Number.isNaN(num)) {
      amount = num.toFixed(2);
    }
  }

  return {
    ...(estados?.length
      ? {
          Estados: estados,
        }
      : {}),
    ...(event?.fecha_desde && dayjs(event?.fecha_desde).isValid()
      ? {
          FechaDesde: dayjs(event?.fecha_desde).toISOString(),
        }
      : {}),
    ...(event?.fecha_hasta && dayjs(event?.fecha_hasta).isValid()
      ? {
          FechaHasta: dayjs(event?.fecha_hasta).toISOString(),
        }
      : {}),
    ...(event?.account_number
      ? {
          NroCuenta: String(event?.account_number?.value),
        }
      : {}),
    ...(event?.sucursal?.length
      ? {
          ClaveSucursal: event?.sucursal,
        }
      : {}),
    ...(event?.request_amount && amount
      ? {
          Monto: amount,
        }
      : {}),
    ...(event?.requester
      ? {
          Solicitante: event?.requester,
        }
      : {}),
  };
};
